import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLoginContext } from "contexts/LoginContext/LoginContext";
import axios from "axios";
import { Event, EventType, Location } from "interfaces/events";
import Title from "antd/lib/typography/Title";
import { Button, Row } from "antd";
import dayjs from "dayjs";
import UpcomingEvents from "./UpcomingEvents/UpcomingEvents";
import PreviousEvents from "./PreviousEvents/PreviousEvents";
import NextEvent from "./NextEvent/NextEvent";

const Events = () => {
  const [events, setEvents] = useState<Event[]>([]);
  const [locations, setLocations] = useState<Location[]>([]);
  const [eventTypes, setEventTypes] = useState<EventType[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const { currentUser } = useLoginContext();

  useEffect(() => {
    if (!currentUser) return;
    axios
      .get<Event[]>(`/companies/${currentUser?.id}/events/`)
      .then(response => {
        setEvents(response.data.sort((a, b) => dayjs(b.start).diff(dayjs(a.start))));
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [currentUser]);

  useEffect(() => {
    axios.get("/events/locations/").then(response => {
      setLocations(response.data);
    });
    axios.get("/events/event-types/").then(response => {
      setEventTypes(response.data);
    });
  }, []);

  return (
    <>
      <Title level={2}>Mine arrangementer</Title>
      <Row justify="end">
        <Link to="/company/event-booking/">
          <Button style={{ background: "var(--secondary-color)", color: "var(--light)" }} size="large">
            Book arrangement
          </Button>
        </Link>
      </Row>
      <br />
      <NextEvent event={events[0]} location={locations.find(l => l.id === events[0]?.location)} />
      <br />
      <UpcomingEvents
        events={events.filter(event => dayjs(event.start) > dayjs())}
        locations={locations}
        eventTypes={eventTypes}
        loading={loading}
      />
      <br />
      <PreviousEvents
        events={events.filter(event => dayjs(event.start) < dayjs())}
        locations={locations}
        eventTypes={eventTypes}
        loading={loading}
      />
    </>
  );
};

export default Events;
